import React, { useEffect, useState } from 'react';
import OutsideClickHandler from 'react-outside-click-handler';
import { useDispatch } from 'react-redux';
import { resetActiveLeftPane, resetPanels, retActiveConversationChannel, useLeftPaneNav } from '../Slice';
import './Channels.scss';
import { CreateChannel, ExploreChannels, RecentChannels, UsersList } from './pages';
import { ArrowBack, ClosePopup, IconUserPlus, IconWorld } from './rootAccess';
import { handleChannelNavigation } from './utils';
import { InviteMembersUsersList } from './pages/UsersList';
import { CreateChannelIcon, IconPlusCircle, IconUserPlusChannel } from '../assets/images';
import CreateChannelPopup from './pages/CreateChannel/CreateChannelPopup';
import CategoryBasedChannels from './pages/CategoryBasedChannels';

const navigationTitles = {
    recentChannelList: 'Channels',
    createChannel: 'Create Channel',
    exploreChannels: 'Channels',
    channelUserList: 'Add Members to Channels',
    inviteUserList: 'Invite Members to Channel',
    categoryChannels: 'Find Channels',
};

const pages = {
    recentChannelList: <RecentChannels />,
    createChannel: <CreateChannel />,
    exploreChannels: <ExploreChannels />,
    channelUserList: <UsersList />,
    inviteUserList: <InviteMembersUsersList />,
    createChannelPopup: <CreateChannelPopup />,
    categoryChannels: <CategoryBasedChannels />,

};

function Channels({ handleChannelsClick }) {
    const [menuDropDownStatus, setMenuDropDownStatus] = useState(false);
    const navigation = useLeftPaneNav();

    const dispatch = useDispatch();
    // treat createChannel and createChannelPopup as modal overlays on top of recentChannelList
    const baseNav = (navigation === 'createChannelPopup' || navigation === 'createChannel') ? 'recentChannelList' : navigation;
    const toggleMenu = () => setMenuDropDownStatus(prev => !prev);
    const closeMenu = () => setMenuDropDownStatus(false);

    useEffect(() => {
        return () => {
            dispatch(retActiveConversationChannel());
            dispatch(resetPanels());
            dispatch(resetActiveLeftPane());
        };
    }, [dispatch]);

    useEffect(() => {
        const isModalOpen = navigation === 'createChannelPopup' || navigation === 'createChannel';
        document.body.style.overflow = isModalOpen ? 'hidden' : '';
        return () => { document.body.style.overflow = ''; };
    }, [navigation]);

    const renderHeader = () => {
        // use baseNav so modal overlays (createChannel/createChannelPopup) keep the background header
        const title = navigationTitles[baseNav] || 'Channels';
        const showBack = ['exploreChannels', 'categoryChannels'].includes(baseNav);

        const showClose = navigation === 'channelUserList' || navigation === 'inviteUserList';
        const showMenuIcon = ['default', 'recentChannelList'].includes(baseNav);

        const handleBackNavigation = () => {
            closeMenu();
            handleChannelNavigation({ pane: 'recentChannelList' });
            if (navigation === 'categoryChannels') {
                handleChannelNavigation({ pane: 'exploreChannels' });
            }
        };
        const handleCloseNavigation = () => {
            closeMenu();
            handleChannelNavigation({ pane: 'createChannelPopup' });
        };

        return (
            <div className="recent-chatlist-header">
                <div className="profile-img-name">
                    {showBack && (
                        <button type="button" className="backarrow" onClick={handleBackNavigation}>
                            <i className='backarrow_icon'>
                                <ArrowBack />
                            </i>
                        </button>
                    )}
                    {showClose && (
                        <button type="button" style={{ fill: '#005386' }} className="close" onClick={handleBackNavigation}>
                            <i className='member_close'>
                                <ClosePopup />
                            </i>
                        </button>
                    )}
                    <h3 className="ting_tittle">{title}</h3>
                </div>

                <div className="profile-options">
                    {showMenuIcon && (
                        <button
                            type="button"
                            className={menuDropDownStatus ? 'menu-icon open' : 'menu-icon'}
                            onClick={toggleMenu}
                            title="More options">
                            {/* <span className="toggleAnimation"></span> */}
                            {/* <IconUserPlusChannel /> */}
                            <IconPlusCircle />
                        </button>
                    )}
                </div>

                {menuDropDownStatus && (
                    <OutsideClickHandler onOutsideClick={closeMenu}>
                        <ul className="menu-dropdown open createchannel_drop">
                            <li>
                                <button className="creatchannel btn" title="New Group " onClick={handleCloseNavigation}>
                                    {/* <IconUserPlus style={{ fill: 'none' }} /> */}
                                    <CreateChannelIcon />
                                    <span>Create New Channel</span>
                                </button>
                            </li>
                            <li>
                                <button
                                    className="explorechannel btn"
                                    title="Explore Channels"
                                    onClick={() => {
                                        closeMenu();
                                        handleChannelNavigation({ pane: 'exploreChannels' });
                                    }}>
                                    <IconWorld />
                                    <span className="explore-channel-text">Explore Channels</span>
                                </button>
                            </li>
                        </ul>
                    </OutsideClickHandler>
                )}
            </div>
        );
    };

    return (
        <>
            {renderHeader()}
            {pages[baseNav]}
            {/* render CreateChannel or CreateChannelPopup as overlay when their navigation is active */}
            {(navigation === 'createChannelPopup' || navigation === 'createChannel') && (
                <div className="channels-overlay-modal" role="dialog" aria-modal="true">
                    {navigation === 'createChannelPopup' ? pages.createChannelPopup : pages.createChannel}
                </div>
            )}

        </>
    );
}

export default React.memo(Channels);
